import { defineComponent as _defineComponent } from 'vue'
import VsHeading from "@/components/vision/VsHeading.vue";
import VsWrapper from "@/components/vision/VsWrapper.vue";
import VsText from "@/components/vision/VsText.vue";
import {computed, unref} from "vue";
import {useGetters} from "vuex-composition-helpers";
import {useGetJobAutomationQuery} from "@/api/jobs-prediction";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'JobPredictionDetails',
  props: {
    jobNumber: null
  },
  setup(__props: any) {

const props = __props as {
  jobNumber: number
}



const {hasAccountOrganizationAccess} = useGetters(
  'permissions',
  ['hasAccountOrganizationAccess']
)

const hasAdminPortalAccess = computed(() => {
  return hasAccountOrganizationAccess.value
})

const {data, isLoading, isSuccess} = useGetJobAutomationQuery(props.jobNumber);

const truncatedId = computed(() => {
  const unrefData = unref(data);
  if (!unrefData) {
    return ''
  }
  return unrefData.triggerId.length > 5 ? unrefData.triggerId.substring(0, 5) + '...' : unrefData.triggerId
})

const etaFullString = computed(() => {
  const computedData = unref(data);


  if (!computedData || computedData?.minutesUntilFull === null) {
    return "-"
  }

  const duration = moment.duration(computedData.minutesUntilFull, 'minutes');

  if (duration.asDays() >= 1) {
    return Math.floor(duration.asDays()) + ' days'
  } else if (duration.asHours() >= 1) {
    return Math.floor(duration.asHours()) + ' hrs';
  } else if (duration.asMinutes() >= 1) {
    return Math.floor(duration.asMinutes()) + ' mins';
  } else {
    return Math.floor(duration.asSeconds()) + ' secs';
  }
  
  
})


return { __sfc: true,props, hasAccountOrganizationAccess, hasAdminPortalAccess, data, isLoading, isSuccess, truncatedId, etaFullString, VsHeading, VsWrapper, VsText }
}

})